/* istanbul ignore file */

/**
 * DEZE FILE STAAT NIET ONDER TEST. WIJZIGINGEN -ALTIJD- CONTROLEREN!
 */

import {
  UitgangspuntenAdvies,
  UitgangspuntenAdviesOutput
} from "../../.generated/instellingen-forms/instellingen-formstypes";
import { useContext, useEffect } from "react";

import useAbortableFetch from "use-abortable-fetch";
import { useRequestInit, ForceRerenderContext } from "adviesbox-shared";

export type UseInstellingenUitgangspuntenAdviesDataResult = {
  error: null | Error;
  data: UitgangspuntenAdvies | null;
  loading: boolean;
};

export const useInstellingenUitgangspuntenAdviesData = (): UseInstellingenUitgangspuntenAdviesDataResult => {
  const {
    requestInit,
    settings: { instellingenFormsOrigin }
  } = useRequestInit();
  const loadingDone = useContext(ForceRerenderContext);

  const url = `${instellingenFormsOrigin}/Uitgangspuntenadvies`;
  const { loading, error, data } = useAbortableFetch<UitgangspuntenAdviesOutput>(url, requestInit);

  useEffect((): void => {
    if (!loading && !!data && loadingDone) {
      loadingDone();
    }
  }, [loading, data, loadingDone]);

  if (typeof data === "string") {
    return { error: new Error("Fout bij het laden van instellingen uitgangspunten data"), data: null, loading: false };
  }

  return { error, data: data ? data.uitgangspuntenAdvies : null, loading };
};
